import { render, staticRenderFns } from "./TotalAmountAdjustmentView.vue?vue&type=template&id=a706138e&scoped=true"
import script from "./TotalAmountAdjustmentView.vue?vue&type=script&lang=js"
export * from "./TotalAmountAdjustmentView.vue?vue&type=script&lang=js"
import style0 from "./TotalAmountAdjustmentView.vue?vue&type=style&index=0&id=a706138e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a706138e",
  null
  
)

export default component.exports